import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import { onAddToast } from '../../../../store/actions';
import { ToastsData } from '../../../../utils/toasts-data';
import { EntityErrorBoundary } from '../../r3f-components/components/boundaries';
import EntitySuspenseBoundary from '../../r3f-components/components/boundaries/EntitySuspense';
const EntityBoundaries = ({ forceError = false, forceLoading = false, rotation, scale, position, floatingInput, renderOrder, label = '', onPointerDown, onPointerUp, children }) => {
    const dispatch = useDispatch();
    return (_jsxs(EntityErrorBoundary, { rotation: rotation, scale: scale, position: position, renderOrder: renderOrder, forceError: forceError, onPointerDown: onPointerDown, onPointerUp: (e) => {
            onPointerUp?.(e);
        }, onError: () => dispatch(onAddToast(ToastsData.FailureLoadingError)), children: [_jsx(EntitySuspenseBoundary, { rotation: rotation, scale: scale, position: position, renderOrder: renderOrder, forceLoading: forceLoading, children: _jsx("group", { name: label, children: children }) }), floatingInput || null] }));
};
export default EntityBoundaries;
